export default __webpack_public_path__ + "static/media/Mark-5-HUD-06.a09dbb8e.jpg";